module.exports = __webpack_public_path__ + "static/media/21ECLAC50.d838de7b.jpg";